import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export function Team() {
  return `
    <section class="team">
      <div class="team__content">
        <div class="team__title-container">
          <h2 class="team__title text-xl font-medium">Il Team</h2>
          <p class="team__desc text-base font-medium">
            Il nostro team è composto da professionisti qualificati, con competenze trasversali in performance, salute e benessere.<br/>
            Un approccio esclusivo, studiato per offrire un’esperienza personalizzata e di alta qualità.
          </p>
        </div>
        <div class="team__members-container swiper team-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/walter-putignano-personal-trainer.webp" 
                alt="Walter Putignano Personal Trainer" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Personal Trainer</p>
                <h3 class="text-lg font-medium">Walter Putignano</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/federica-sbiroli-personal-trainer.webp" 
                alt="Federica Sbiroli Personal Trainer" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Personal Trainer</p>
                <h3 class="text-lg font-medium">Federica Sbiroli</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/giuliano-delfine-personal-trainer.webp" 
                alt="Giuliano Delfine Personal Trainer" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Personal Trainer</p>
                <h3 class="text-lg font-medium">Giuliano Delfine</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/gabriele-andresini-personal-trainer.webp" 
                alt="Gabriele Andresini Personal Trainer" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Personal Trainer</p>
                <h3 class="text-lg font-medium">Gabriele Andresini</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/alessia-rizzi-istruttrice-pilates.webp" 
                alt="Alessia Rizzi Istruttrice Pilates" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Istruttrice Pilates Reformer</p>
                <h3 class="text-lg font-medium">Alessia Rizzi</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/fabiana-tria-istruttrice-pilates.webp" 
                alt="Fabiana Tria Istruttrice Pilates" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Istruttrice Pilates Reformer</p>
                <h3 class="text-lg font-medium">Fabiana Tria</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/alessandra-bianco-fisioterapista.webp" 
                alt="Alessandra Bianco Fisioterapista" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Fisioterapista</p>
                <h3 class="text-lg font-medium">Alessandra Bianco</h3>
              </div>
            </div>
            <div class="swiper-slide team__member">
              <img 
                src="/images/team/alessandro-maggi-nutrizionista.webp" 
                alt="Alessandro Maggi Nutrizionista" 
                draggable="false"
              />
              <div class="team__member-info">
                <p class="text-sm font-medium">Nutrizionista</p>
                <h3 class="text-lg font-medium">Alessandro Maggi</h3>
              </div>
            </div>
          </div>
          <div class="swiper-button-prev team__arrow team__arrow--left">
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M6.48581 0.292969L0.778704 6.00007L6.48581 11.7072L7.90002 10.293L3.60713 6.00007L7.90002 1.70718L6.48581 0.292969Z" fill="white"/>
            </svg>
          </div>
          <div class="swiper-button-next team__arrow team__arrow--right">
            <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.51431 11.707L7.22142 5.99993L1.51431 0.292818L0.100099 1.70703L4.39299 5.99993L0.100098 10.2928L1.51431 11.707Z" fill="white"/>
            </svg>
          </div>
        </div>
      </div>
    </section>
  `;
} 

export function enableTeamSlider() {
  new Swiper('.team-swiper', {
    modules: [Navigation],
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    spaceBetween: 96,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 'auto',
        spaceBetween: 24,
      },
      768: {
        slidesPerView: 'auto',
        spaceBetween: 96,
      }
    }
  });
}